module.exports = __webpack_public_path__ + "static/2-7ba2910e7aa8901d2e4a19df9059ff43.svg";